module.exports = __webpack_public_path__ + "static/media/jll.54d8fe67.png";